// Vendor
import { computed } from 'vue';
import { useQuasar } from 'quasar';

// Stores
import { useRouterStore } from 'src/stores/router';

export function useGlobalVM() {
  // Init stores
  const routerStore = useRouterStore();

  // Quasar
  const $q = useQuasar();

  const isMobile = computed(
    () => $q.screen.gt.xs !== true || $q.platform.is.mobile == true,
  );

  /**
   * Functions
   */
  const vmOnClose = (uuidToClose?: string) => {
    if (uuidToClose != null) {
      routerStore.removeOpenedModal(uuidToClose);
    }
  };

  return {
    isMobile,

    // Methods
    vmOnClose,
  };
}
